/* eslint-disable max-len */
import 'react';

const OffSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g
            stroke="#FFF"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            fillRule="evenodd"
        >
            <path d="M3.486 2.052A5 5 0 108.422 2M6 1v4" />
        </g>
    </svg>
);

export default OffSvg;
